import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';
import { MessagingSettings } from '@gokrew/ui';
import { usePermissions } from '@/context/PermissionContext';
import { permissionKeys } from '@/utility';
import styles from './MessagingSettings.module.css';

export const MessagingSettingsPage = () => {
  const { t } = useTranslation(TranslationNS.Sidebar);
  const { permissions } = usePermissions();
  return (
    <div className={styles.page}>
      <NavLink to="/organization" className={styles.back}>
        {t('nav.organization')}
      </NavLink>
      <MessagingSettings
        readOnly={!permissions.has(permissionKeys.company.update)}
      />
    </div>
  );
};
